// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import loading from '../../../../share/components/vue/ProcessingIcon';
import specialFeature from '../../../../share/util/specialFeature';
import config from '../../../../share/config';

/**
 * 特殊機能個別システム診断表示用マップ
 * key: APIから取得した個別診断メニュー構成情報のkey
 * type: 個別診断機能遷移用定義
 * label: 個別診断機能のラベルKey
 */
const SPECIAL_INDIVIDUAL_FUNCTION_MAP = [
  { key: 'diag_code', type: config.SPECIAL_FEATURE_DIAG_CODE, label: 'individual.individual_diagnosis_function_diag_code' },
  { key: 'vehicle_control_history', type: config.SPECIAL_FEATURE_VEHICLE_CONTROL_HISTORY, label: 'individual.individual_diagnosis_function_vehicle_control_history' },
  { key: 'cancel_code', type: config.SPECIAL_FEATURE_CANCEL_CODE, label: 'individual.individual_diagnosis_function_cancel_code' },
  { key: 'data_monitor', type: config.SPECIAL_FEATURE_DATA_MONITOR, label: 'individual.individual_diagnosis_function_data_monitor' },
  { key: 'work_support', type: config.SPECIAL_FEATURE_WORK_SUPPORT, label: 'individual.individual_diagnosis_function_work_support' },
];

export default {
  name: "specialFeatureSelect",
  data() {
    return {
      processing: false,
      spListItems: [],
    };
  },

  watch: {
    language: {
      immediate: true,
      handler(val) {
        val; // To avoid warning
      }
    },
  },

  components: {
    'processing-view': loading,
  },

  // router params 対応
  props: ["systemId"],

  methods: {
    ...mapActions('auth', ['logout']),

    /**
     * アイコンのクリック処理
     */
    clickItem(routeName) {
      const routerData = {
        name: routeName,
        params: {
          systemId: this.systemId
        }
      };
      // 初期化通信有無のための同じシステム内遷移判定
      if (this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, 'sameSystemFlg')) {
        routerData.query = { sameSystemFlg: this.$route.query.sameSystemFlg };
      }
      this.$router.push(routerData);
      // 画面上部へのアンカースクロール
      document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
    },

    /**
     * 特殊機能一覧のリストを更新する
     */
    updateSpTable() {
      const menuList = this.individualMenus ? this.individualMenus.menu_list : [];
      const systemId = this.systemId;

      const specialFeatureList = SPECIAL_INDIVIDUAL_FUNCTION_MAP.filter(
        (data) => {
          const targetMenu = menuList.find(menu => menu.system_name === systemId);
          if (!targetMenu || !targetMenu.menu_display_config) {
            return false;
          }

          // 特殊機能のダイアグコード、キャンセルコードの場合はspecial_feature_menu_display_configを確認する
          if (data.type === config.SPECIAL_FEATURE_DIAG_CODE || data.type === config.SPECIAL_FEATURE_CANCEL_CODE) {
            if (!targetMenu.special_feature_menu_display_config) {
              return false;
            }
            return Object.keys(targetMenu.special_feature_menu_display_config).some(individualKey =>
              // special_feature_menu_display_configに対象の個別診断機能のkeyが存在し、値がtrueの場合、個別診断のツリーを作成する
              individualKey === data.key &&
              targetMenu.special_feature_menu_display_config[individualKey]
            );
          }

          // 画面名と同様に特殊機能の制御作動履歴は通常の menu_display_config を見る
          return Object.keys(targetMenu.menu_display_config).some(individualKey =>
            // menu_display_configに対象の個別診断機能のkeyが存在し、値がtrueの場合、メニューに表示する
            individualKey === data.key &&
            targetMenu.menu_display_config[individualKey]
          );
        }
      ).map((item) => {
        return {
          name: item.label,
          route_name: item.type
        };
      });

      this.spListItems = specialFeatureList;
    }
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      individualMenus: state => state.vehicle.individualMenus,
    }),
    /**
     * 選択しているシステム名を返却
     */
    selectedSystemName() {
      return `diagSytem.${this.systemId}`;
    }
  },

  created() {
  },

  mounted() {
    // ツリーから特殊機能ノードが選択されて遷移してきた時
    if (this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, 'funcId') && Object.prototype.hasOwnProperty.call(this.$route.params, 'systemId')) {
      // 特殊機能の選択された機能に遷移する
      specialFeature.moveSpecialFeatureScreen(
        this,
        this.systemId,
        this.$route.query.funcId,
      );
      return;
    }

    // タブ制御
    this.$emit("setVehicleTabsAvailable", true);
    this.updateSpTable();
  },

};
